import EditService from './edit_main.js'
import ViewService from './view_main.js'
import Utils from '../utils/utils'
import HtmlHelper from "../utils/HtmlHelper"

export default class OptimizePage {
    constructor(container_id, config, is_debug, storage_key) {
        this.container_id = container_id
        this.config = config
        this.is_debug = is_debug
        this.storage_key = storage_key
        this.utils_helper = new Utils()
        this.html_helper = new HtmlHelper()
    }
  
    async run() {
        
        try {
            console.log('optimize99_abtest_feature_run: ', this.container_id)
            if (document.readyState === 'complete') {
                console.log('optimize99_start_view: 頁面載完')
                this.startView('complete')
            } 
            else {
                console.log('optimize99_start_view: 頁面還沒載完')
                window.addEventListener('load', (e)=> {
                    console.log('optimize99_start_view_event:', e)
                    this.startView('eventlistener')
                });
            }
            // 如果是後台編輯模式，網址會帶這個
            if (window.location.href.indexOf('opt99_edit') !== -1 ){
    
                // 載入完call back給後台Container的message listener
                if (document.readyState === 'complete') {
                    console.log('optimize_start_edit: 頁面載完')
                    this.startEdit('complete')
                }
                else {
                    console.log('optimize_start_edit: 頁面還沒載完')
                    window.addEventListener('load', () => {
                        this.startEdit('eventlistener')
                    });
                }

                // trigger alt feedback
                document.addEventListener('keydown',(e) => {
                    if (e.key === 'Alt') {
                        window.parent.postMessage({ action: 'trigger_alt', data: 'keydown' }, '*')
                    }
                })
                document.addEventListener('keyup', (e) => {
                    if (e.key === 'Alt') {
                        window.parent.postMessage({ action: 'trigger_alt', data: 'keyup' }, '*')
                    }
                })

                let that = this
                const editService = new EditService(this.container_id)
                const operationType = async (data) => {
                    const action = data.action
                    switch (action){
                        case 'getHistory':
                            console.log('getHistory :', data)
                            const history = data.data.history
                            for (let i = 0; i < history.length; i++) {
                                const item = history[i]
                                const isLast = i === history.length - 1

                                await operationType(item)
                                if (isLast && window.AOS) {
                                    setTimeout(() => {
                                        window.AOS.refreshHard();
                                    }, 1000)   
                                }
                            }
                            break
                        case 'startEdit':
                            console.log('edit')
                            editService.start(data.option)
                            break;
                        case 'updateElement':
                            console.log('update_element')
                            editService.updateElement(data.data, data.type, data.vid, data.is_by_step)
                            break;
                        case 'editText':
                            console.log('editText',data)
                            editService.editText(data)
                            break;
                        case 'getElementInfo':
                            console.log('getElementInfo')
                            editService.getElementInfo(data.selector, data.method)
                            break;
                        case 'sortElement':
                            console.log('sortElement')
                            editService.sortElement(data.data)
                            break
                        case 'actionToPage':
                            console.log('actionToPage')
                            editService.actionToPage(data.data)
                            break
                        case 'carousel':
                            console.log('carousel')
                            await editService.carousel(data.data)
                            break
                        default:
                            console.log('not_match_action', data.action)
                            console.log('not_match_action_data',data)
                            // 沒有action的話，檢查是不是有data欄位，有的話代表詳細資料在裡面
                            if (data.data) {
                                editService.updateElement(data.data, data.type, data.vid, data.data.is_by_step)
                            }
                            // 沒有的話代表data本身就是詳細資料
                            else {
                                if (data.type) {
                                    editService.updateElement(data, 'next', data.vid, data.is_by_step)
                                }
                            }
                    }
                }
                window.addEventListener('message',  async (e) => {
                    if (e.origin.indexOf(that.config.DOMAIN) === -1){
                        return
                    }

                    let data = JSON.parse(e.data)
                    if (data.container_id !== that.container_id) {
                        console.log('not_match_container')
                        console.log('current:', that.container_id)
                        console.log('send_by:', data.container_id)
                        return
                    }

                    await operationType(data)
                })
            }
        } catch (error) {
            throw Error(error)
        }

    }

    startEdit(type){
        try {
            console.log('optimize99_abtest_feature_edit_start', type)
            parent.postMessage({
                'action': 'init_callback',
                'container_id': this.container_id
            }, '*')
        }
        catch (error) {
            throw Error(error)
        }
    }

    startView(type) {
        try {
            console.log('optimize99_abtest_feature_view_start', type)
            const viewService = new ViewService(this.config, this.container_id, this.is_debug, this.storage_key)
            viewService.start()
            
        } catch(error){
            throw Error(error)
        }
    }
}
